import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import { createUrlAliasVariables } from '@api/graphql/types';
import UrlAliasForm from '../components/UrlAliasForm';

type Props = {
} & InjectedIntlProps & RouteComponentProps;


interface State {
    formData: createUrlAliasVariables;
}

class UrlAliasCreate extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            formData: {
                source_url: '',
                target_url: '',
            },
        };
    }

    public onSubmit = (variables: createUrlAliasVariables) => {
        return GraphQLClient.mutate({
            mutation: Mutations.createUrlAlias, variables,
        });
    }

    public render() {
        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>{this.props.intl.formatMessage({ id: 'module.urlAlias.create.title'})}</h5>
                        </div>
                        <div className="ibox-content">
                            {this.state.formData &&
                                <UrlAliasForm formData={this.state.formData} onSubmit={this.onSubmit}/>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    injectIntl,
    withRouter,
)(UrlAliasCreate);



// WEBPACK FOOTER //
// ./src/modules/UrlAlias/pages/UrlAliasCreate.tsx